// extracted by mini-css-extract-plugin
export default {"container":"NavButton_container__bFqDb","link":"NavButton_link__eU+nQ"};